export type CareInstruction = {
  title: string | null
  text: string
}

export function looksLikeHtml(value: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(value)
}

export function stripHtml(value: string): string {
  return value
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&#39;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Parse admin-provided care HTML (often a full document with <li><strong>Title:</strong> text). */
export function parseCareInstructionsHtml(html: string): CareInstruction[] {
  const items: CareInstruction[] = []
  const liPattern = /<li\b[^>]*>([\s\S]*?)<\/li>/gi
  let match: RegExpExecArray | null
  while ((match = liPattern.exec(html)) !== null) {
    const inner = match[1] ?? ''
    const strongMatch = /<strong\b[^>]*>([\s\S]*?)<\/strong>/i.exec(inner)
    const title = strongMatch
      ? stripHtml(strongMatch[1] ?? '')
          .replace(/:\s*$/, '')
          .trim() || null
      : null
    const textSource = strongMatch
      ? inner.replace(strongMatch[0], ' ')
      : inner
    const text = stripHtml(textSource)
    if (!title && !text) continue
    items.push({ title, text: text || title || '' })
  }
  return items
}
